<evsb-card
  *ngFor="let speed of availableSpeeds$ | async"
  [variant]="chosenSpeed === speed.code ? 'myDrive' : 'blank'"
  class="mb-5"
  [selected]="chosenSpeed === speed.code"
>
  <label [attr.for]="'chargingSpeed_' + speed.code" class="cursor-pointer">
    <evsb-card-header variant="light">
      <h2 heading class="text-grey-dark font-sans text-lg font-medium">
        {{ getLabels(speed).title | translate }}
      </h2>
      <div class="flex justify-center items-center h-full">
        <input
          type="radio"
          name="chargingSpeed"
          class="hidden"
          [id]="'chargingSpeed_' + speed.code"
          [value]="speed.code"
          [(ngModel)]="chosenSpeed"
          (ngModelChange)="updateSpeed()"
        />
        <figure
          class="flex items-center justify-center w-8 h-8 rounded-full bg-grey-light border border-grey-dark60"
          style="padding: 2px"
        >
          <div class="w-full h-full rounded-full flex"></div>
        </figure>
      </div>
    </evsb-card-header>
  </label>
  <evsb-card-body>
    <main class="flex flex-row gap-3 justify-between">
      <ul class="list-outside list-disc ml-7">
        <li class="text-grey text-xl leading-4">
          <span class="text-grey-dark text-xs relative -inset-x-2">{{ getLabels(speed).list1 | translate }}</span>
        </li>
        <li class="text-grey text-xl leading-4 mt-2">
          <span class="text-grey-dark text-xs relative -inset-x-2">{{ getLabels(speed).list2 | translate }}</span>
        </li>
        <li class="text-grey text-xl leading-4 mt-2">
          <span class="text-grey-dark text-xs relative -inset-x-2">{{ getLabels(speed).list3 | translate }}</span>
        </li>
      </ul>
      <figure class="w-36 flex-shrink-0">
        <img [src]="getLabels(speed).img" class="w-100" />
      </figure>
    </main>
    <footer class="border-t border-grey-100 mt-5 pt-5">
      <evsb-details [label]="'modules.evsb.details' | translate">
        <evsb-currency-lg [amount]="speed.price" currency="€" [end]="'modules.evsb.chargingStation.input.type.perChargingStation' | translate" heading></evsb-currency-lg>
        <section class="pt-8">
          <evsb-nav-tabs>
            <evsb-nav-tab title="{{ getLabels(speed).details1.title | translate }}">
              <p
                class="text-grey-dark text-xs antialiased"
                [innerHtml]="getLabels(speed).details1.text | translate"
              ></p>
            </evsb-nav-tab>
            <evsb-nav-tab title="{{ getLabels(speed).details2.title | translate }}">
              <p
                class="text-grey-dark text-xs antialiased"
                [innerHtml]="getLabels(speed).details2.text | translate"
              ></p>
            </evsb-nav-tab>
            <evsb-nav-tab title="{{ getLabels(speed).details3.title | translate }}">
              <p
                class="text-grey-dark text-xs antialiased"
                [innerHtml]="getLabels(speed).details3.text | translate"
              ></p>
            </evsb-nav-tab>
          </evsb-nav-tabs>
        </section>
      </evsb-details>
    </footer>
  </evsb-card-body>
</evsb-card>
